import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts';
import { Spinner } from 'components/ui/spinner';

const BeninDepartmentsStats = ({ stats, paidBase }) => {
  const [mapState, setMapState] = useState('loading');
  useEffect(() => {
    let mounted = true;
    import('../../../assets/maps/benin.json')
      .then((module) => {
        echarts.registerMap('Benin', module.default || module);
        if (mounted) setMapState('ready');
      })
      .catch(() => {
        if (mounted) setMapState('error');
      });
    return () => {
      mounted = false;
    };
  }, []);
  const rows = stats
    .map((row) => ({ ...row, name: row.name.charAt(0) + row.name.slice(1).toLowerCase() }))
    .sort((a, b) => b.value - a.value || a.name.localeCompare(b.name, 'fr'));
  const max = Math.max(1, ...rows.map((row) => row.value));
  const option = {
    tooltip: { trigger: 'item', renderMode: 'richText', textStyle: { fontSize: 14 } },
    visualMap: {
      min: 0,
      max,
      left: 'center',
      bottom: 10,
      orient: 'horizontal',
      itemWidth: 8,
      itemHeight: 100,
      text: [`${max} pèlerins`, '0'],
      textStyle: { fontSize: 14 },
      inRange: { color: ['#e2f0e9', '#16754f'] },
      calculable: false,
    },
    series: [
      {
        type: 'map',
        map: 'Benin',
        roam: false,
        top: 5,
        bottom: 60,
        label: { show: false },
        itemStyle: { borderColor: '#ffffff', borderWidth: 1 },
        emphasis: { label: { show: false } },
        data: rows,
      },
    ],
  };
  return (
    <>
      {paidBase != null && (
        <p className="-mt-2 mb-4 text-sm text-slate-500">{paidBase.toLocaleString('fr-FR')} pèlerins soldés</p>
      )}
      <div className="grid items-center gap-6 lg:grid-cols-[2fr_3fr]">
        <div
          className="h-[340px] min-w-0"
          role="img"
          aria-label="Carte du Bénin : effectifs par département détaillés dans la liste"
        >
          {mapState === 'loading' && <Spinner />}
          {mapState === 'error' && (
            <p className="text-sm text-slate-500">
              Carte indisponible. Les effectifs restent disponibles dans la liste.
            </p>
          )}
          {mapState === 'ready' && <ReactECharts option={option} style={{ height: '100%', width: '100%' }} />}
        </div>
        <div className="space-y-3">
          {rows.map((row) => (
            <div key={row.name} className="grid grid-cols-[100px_1fr_auto] items-center gap-3 text-sm">
              <span>{row.name}</span>
              <div className="h-1.5 overflow-hidden rounded-sm bg-slate-100" aria-hidden="true">
                <div className="h-full bg-hajj-primary" style={{ width: `${(row.value / max) * 100}%` }} />
              </div>
              <strong className="text-right">{row.value.toLocaleString('fr-FR')}</strong>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
export default BeninDepartmentsStats;
